import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { RecoverPasswordRequest } from '../../requests/platform/recover-password.request';
import { RecoverPasswordResponse } from '../../responses/platform/recover-password.response';
import { ResetarSenhaRequest } from '../../requests/platform/resetar-senha.request';

@Injectable({
  providedIn: 'root',
})
export class PasswordChangeService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public post(recoverPasswordRequest: RecoverPasswordRequest): Observable<RecoverPasswordResponse> {
    return this.httpClient
      .post<RecoverPasswordResponse>(environment.urlApiPlatform + 'PasswordChange', recoverPasswordRequest)
      .pipe(catchError(this.handleError));
  }

  public get(token: string): Observable<ReturnStruct> {
    return this.httpClient
      .get<ReturnStruct>(environment.urlApiPlatform + 'PasswordChange/token/' + token)
      .pipe(catchError(this.handleError));
  }

  public put(resetarSenhaRequest: ResetarSenhaRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(environment.urlApiPlatform + 'PasswordChange', resetarSenhaRequest)
      .pipe(catchError(this.handleError));
  }
}
